import { LocalStorageKeys } from './storageUtils';

export function storeLocationList(locationList) {
  localStorage.setItem(LocalStorageKeys.LOCATION_LIST, JSON.stringify(locationList));
}

export function getLocationList() {
  const storedData = localStorage.getItem(LocalStorageKeys.LOCATION_LIST);
  return storedData ? JSON.parse(storedData) : {};
}

export function getLodgeDataByCode(locationCode) {
  const locationList = getLocationList();
  return locationList[locationCode] || {};
}

export const getResortLocationUrl = (withSlashes = true) => {
  const urlParts = window.location.pathname.split('/');
  const RESORT_LOCATION_URL_PARAM_POSITION = 1;
  const resortLocation = urlParts[RESORT_LOCATION_URL_PARAM_POSITION];

  return withSlashes ? `/${resortLocation}/` : resortLocation;
};

export const getResortShortName = () => {
  return getResortLocationUrl(false);
};

export function getCurrentResortData() {
  const locationList = getLocationList();
  const resortShortName = getResortShortName();
  const locationData = Object.values(locationList).find(location => location.url === resortShortName);

  return {
    resortDisplay: locationData?.display ?? '',
    resortPhone: locationData?.phone ?? '',
    resortAddress: locationData?.address ?? '',
    resortCode: locationData?.operaCode ?? ''
  };
}
